import { render, staticRenderFns } from "./ItemIrmao.vue?vue&type=template&id=f05541f6"
import script from "./ItemIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports